window.addEventListener("load", (event) => {
  applyFilters();
  sortByoptions();
  // SidedrawerEventInit();
});

window.addEventListener("resize", (event) => {
  if (window.innerWidth > 1024 && document.querySelector("#Collection-filter-sidebar")) {
    document.querySelector("#Collection-filter-sidebar").style.removeProperty("display");
  }
});

let triggered = false;

/* =========================
   ★ 追加：ローディング関連
   ========================= */
let currentController = null; // 直前のリクエストを中断するため
let filterOverlay = null; // 画面中央のローディングオーバーレイ

function ensureFilterOverlay() {
  if (filterOverlay && document.body.contains(filterOverlay)) return;

  const ov = document.createElement("div");
  ov.id = "filter-loading-overlay";
  Object.assign(ov.style, {
    position: "fixed",
    inset: "0",
    background: "rgba(255,255,255,0.7)",
    display: "none",
    zIndex: "9999",
    alignItems: "center",
    justifyContent: "center",
  });
  ov.setAttribute("role", "status");
  ov.setAttribute("aria-live", "polite");

  // 中央のボックス
  const box = document.createElement("div");
  Object.assign(box.style, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    padding: "16px 18px",
    borderRadius: "12px",
    background: "rgba(255,255,255,0.95)",
    boxShadow: "0 6px 30px rgba(0,0,0,0.08)",
  });

  // SVG スピナー
  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, "svg");
  svg.setAttribute("width", "40");
  svg.setAttribute("height", "40");
  svg.setAttribute("viewBox", "0 0 50 50");
  svg.setAttribute("aria-hidden", "true");

  const circle = document.createElementNS(svgNS, "circle");
  circle.setAttribute("cx", "25");
  circle.setAttribute("cy", "25");
  circle.setAttribute("r", "20");
  circle.setAttribute("fill", "none");
  circle.setAttribute("stroke", "#000");
  circle.setAttribute("stroke-width", "4");
  circle.setAttribute("opacity", "0.2");

  const arc = document.createElementNS(svgNS, "path");
  arc.setAttribute("d", "M25 5 a20 20 0 0 1 0 40");
  arc.setAttribute("fill", "none");
  arc.setAttribute("stroke", "#000");
  arc.setAttribute("stroke-width", "4");
  arc.setAttribute("stroke-linecap", "round");

  const anim = document.createElementNS(svgNS, "animateTransform");
  anim.setAttribute("attributeName", "transform");
  anim.setAttribute("type", "rotate");
  anim.setAttribute("from", "0 25 25");
  anim.setAttribute("to", "360 25 25");
  anim.setAttribute("dur", "0.8s");
  anim.setAttribute("repeatCount", "indefinite");
  arc.appendChild(anim);

  svg.appendChild(circle);
  svg.appendChild(arc);

  const label = document.createElement("div");
  label.textContent = "絞り込み中…";
  Object.assign(label.style, { fontSize: "14px", fontWeight: "600", color: "#333" });

  box.appendChild(svg);
  box.appendChild(label);
  ov.appendChild(box);
  document.body.appendChild(ov);

  filterOverlay = ov;
}

function setLoadingOverlay(isLoading) {
  ensureFilterOverlay();
  if (!filterOverlay) return;
  filterOverlay.style.display = isLoading ? "flex" : "none";
}

/* =========================
   fetch を中断対応に
   ========================= */
function fetchFilterData(url, signal = undefined) {
  return fetch(url, { signal }).then((response) => response.text());
}

function applyFilters() {
  let section = document.getElementById("CollectionProductsParent");
  let filterForm = document.getElementById("FiltersForm");
  if (section) {
    let sectionParent = section.closest(".shopify-section");
    let sectionId = section.dataset.id;
    if (!filterForm) {
      return false;
    }
    collection_price_range(sectionId, sectionParent);
    let inputs = filterForm.querySelectorAll("input[type=checkbox]");
    Array.from(inputs).forEach(function (input) {
      input.addEventListener("click", () => {
        SidedrawerEventInit();
        getFilterData(input, sectionId);
      });
    });
  }
}

function sortByoptions() {
  let section = document.querySelector(".collection-wrapper");
  let sortBy = document.querySelectorAll('[name="sort_by"]');
  if (section) {
    let sectionId = section.querySelector(".collection_products").dataset.id;
    Array.from(sortBy).forEach(function (sort) {
      sort.addEventListener("change", (e) => {
        e.preventDefault();
        sort.closest(".collection-sortby-item").classList.remove("selected");
        sort.closest(".collection-sortby-item").classList.add("selected");
        let sortMenu = section.querySelector(".collection-sortby-inner");
        let sortList = sortMenu.querySelector(".collection-sortby-detail");
        if (sortMenu.hasAttribute("open")) {
          DOMAnimations.slideUp(sortList);
        }
        SidedrawerEventInit();
        getFilterData(sort, sectionId);
      });
    });
  }
}

function getFilterData(input, sectionId, remove, minPriceRange, maxPriceRange) {
  let section = document.getElementById("CollectionProductsParent");
  let sectionParent = section.closest(".shopify-section");
  let filterForm = document.getElementById("FiltersForm");
  let formData = new FormData(filterForm);
  let searchParameters = new URLSearchParams(formData).toString();
  let url = window.location.pathname + "?section_id=" + sectionId + "&" + searchParameters;
  let updateUrl = window.location.pathname + "?" + searchParameters;
  if (remove) {
    url = remove;
    updateUrl = remove;
  }

  // ★ 現在のスクロール位置を保存
  const prevScrollY = window.scrollY;
  // ★ ローディング表示（画面中央）
  setLoadingOverlay(true);
  // ★ 直前のリクエストがあれば中断
  if (currentController) currentController.abort();
  currentController = new AbortController();

  fetchFilterData(url, currentController.signal)
    .then((responseText) => {
      let resultData = new DOMParser().parseFromString(responseText, "text/html");
      let itemResultcount = resultData.querySelector(".Product-result .total_products");
      let element = document.getElementById("CollectionProductsParent");
      let html = resultData.getElementById("CollectionProductsParent");
      let mobileSort = document.querySelector("[data-mobile-sort]");
      let resultMobileSort = resultData.querySelector("[data-mobile-sort]");
      let searchSort = document.querySelector("[data-search-sort]");
      let resultSearchSort = resultData.querySelector("[data-search-sort]");
      let filter_element = document.querySelector(".collection-filter-sidebar");
      let filter_html = resultData.querySelector(".collection-filter-sidebar");
      if (element) {
        element.innerHTML = html.innerHTML;
        let scrollDiv = document.getElementById("CollectionProductsParent");
        if (mobileSort && resultMobileSort) {
          mobileSort.innerHTML = resultMobileSort.innerHTML;
        }
        if (searchSort && resultSearchSort) {
          searchSort.innerHTML = resultSearchSort.innerHTML;
        }

        // ★ レイアウト確定後に元の位置へ戻す（iOS/Safari 対策で rAF）
        requestAnimationFrame(() => {
          window.scrollTo({ top: prevScrollY, behavior: "auto" });
        });

        filter_element.innerHTML = filter_html.innerHTML;
        applyFilters();
        remove_filter(sectionParent, sectionId);
        SidedrawerEventInit();
      } else {
        let productResultContainer = element.querySelector("[data-collection-products]");
        if (productResultContainer) {
          productResultContainer.innerHTML = noResultFound;
        }
      }
      collectionSwatch();
      history.pushState({}, null, updateUrl);
      sortByoptions();
      triggered = false;
      loadMoreCollection();
      getCountDownElments();
      quickviewElements();
      customDropdownElements();
      SidedrawerEventInit();
      productCardHoverInit();
      if (aosAnimation) {
        if (typeof AOS !== 'undefined') {
          AOS.refreshHard();
        }
      }
    })
    .catch((e) => {
      // 中断は無視。それ以外はログ
      if (e && e.name !== "AbortError") console.error(e);
    })
    .finally(() => {
      // ★ ローディング非表示 & コントローラ解放
      setLoadingOverlay(false);
      currentController = null;
    });
}

function scrollIntoView(selector, offset = 0) {
  window.scroll(0, selector.offsetTop - offset);
}

function remove_filter(sectionParent, sectionId) {
  var removeFilters = sectionParent.querySelectorAll("a.sr-applied-filter-remove");
  Array.from(removeFilters).forEach(function (removeFilter) {
    removeFilter.addEventListener("click", function (event) {
      event.preventDefault();
      if (removeFilter.hasAttribute("sr-applied-filter-cross-all")) {
        var _url = removeFilter.getAttribute("href");
        getFilterData(removeFilter, sectionId, _url);
        return false;
      } else {
        var _url = removeFilter.getAttribute("href");
        getFilterData(removeFilter, sectionId, _url);
      }
    });
  });
}

function collection_price_range(sectionId, sectionParent) {
  const rangeInput = document.querySelectorAll(".sr-range-input input"),
    priceInput = document.querySelectorAll(".sr-price-input input"),
    range = document.querySelector("#priceSilderProgress");
  if (rangeInput.length > 0) {
    let priceGap = rangeInput[0].getAttribute("step");
    priceInput.forEach((input) => {
      input.addEventListener("change", (e) => {
        let minPrice = parseInt(priceInput[0].value),
          maxPrice = parseInt(priceInput[1].value),
          maxPriceRange = parseInt(priceInput[1].getAttribute("data-max-value"));
        if (minPrice > maxPriceRange) {
          minPrice = maxPriceRange;
          priceInput[0].value = minPrice;
        }
        getFilterData(input, sectionId);
      });
    });
    rangeInput.forEach((input) => {
      input.addEventListener("change", (event) => {
        rangeSlider(input, event);
        getFilterData(input, sectionId);
      });
      input.addEventListener("input", (event) => {
        rangeSlider(input, event);
      });
    });
    var rangeSlider = function (input, event) {
      let minVal = parseInt(rangeInput[0].value),
        maxVal = parseInt(rangeInput[1].value);
      minPriceRange = Math.max(0, (minVal / rangeInput[0].max) * 100);
      maxPriceRang = Math.max(0, 100 - (maxVal / rangeInput[1].max) * 100);
      if (maxVal - minVal < priceGap) {
        if (event.target.className === "priceslider-range-min") {
          rangeInput[0].value = maxVal - priceGap;
        } else {
          rangeInput[1].value = minVal + priceGap;
        }
      } else {
        priceInput[0].value = minVal;
        priceInput[1].value = maxVal;
        range.style.left = minPriceRange + "%";
        range.style.right = maxPriceRang + "%";
      }
    };
  }
}

// Infinite scroll
function Onscrollproducts() {
  window.addEventListener("scroll", function () {
    let scrollElement = document.querySelector("[data-scroll]");
    if (scrollElement) {
      infiniteScroll(scrollElement);
    }
  });
}

function infiniteScroll(scrollElement) {
  if (scrollElement && scrollElement.querySelector("a")) {
    let nextUrl = scrollElement.querySelector("a").getAttribute("href");
    if (isOnScreen(scrollElement) && triggered == false) {
      triggered = true;
      scrollElement.querySelector("a").remove();
      scrollElement.querySelector(".load").classList.remove("hidden");
      fetchFilterData(nextUrl).then((responseText) => {
        scrollElement.remove();
        const resultData = new DOMParser().parseFromString(responseText, "text/html");
        let html = resultData.querySelector("#CollectionProductsParent");
        let element = document.querySelector("#CollectionProductsParent");
        /* result for the collection page */
        if (html) {
          element.querySelector("[data-collection-products]").innerHTML +=
            html.querySelector("[data-collection-products]").innerHTML;
          getCountDownElments();
          triggered = false;
          loadMoreCollection();
          quickviewElements();
          productCardHoverInit();
          if (aosAnimation) {
            if (typeof AOS !== 'undefined') {
              AOS.refreshHard();
            }
          }
        }
      });
    }
  }
}

function loadMoreCollection(section = document) {
  let loadmoreButton = section.querySelector("[data-products-load]");
  if (loadmoreButton) {
    loadmoreButton.addEventListener("click", function (event) {
      event.preventDefault();
      let scrollElement = loadmoreButton.closest("[data-load-more]");
      if (scrollElement) {
        infiniteScroll(scrollElement);
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  Onscrollproducts();
  loadMoreCollection();
});

document.addEventListener("shopify:block:select", function (event) {
  let _block = event.target;
  Onscrollproducts(_block);
  loadMoreCollection(_block);
});

document.addEventListener("shopify:section:load", function (event) {
  let _section = event.target;
  Onscrollproducts(_section);
  loadMoreCollection(_section);
});

/* フィルタリスト「もっと見る / 閉じる」 */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-filter-toggle]');
  if (!btn) return;
  var wrapper = btn.closest('.filter-list-collapsible');
  if (!wrapper) return;
  wrapper.classList.toggle('is-collapsed');
  btn.textContent = wrapper.classList.contains('is-collapsed') ? 'もっと見る' : '閉じる';
});
